// Rôles RBAC côté front — source unique (miroir de backend/constants/roles.js).
// 'admin' conservé pour compat descendante (tokens émis avant le rename E4).
export const ROLES = Object.freeze({
  SUPERADMIN: "superadmin",
  ORG_ADMIN: "org_admin",
  USER: "user",
  ADMIN_LEGACY: "admin",
});

// Admin de son org (ou superadmin) : accès total dans le périmètre org.
export function isOrgAdmin(user) {
  const r = user?.role;
  return r === ROLES.ORG_ADMIN || r === ROLES.SUPERADMIN || r === ROLES.ADMIN_LEGACY;
}

// Éditeur SaaS (cross-tenant).
export function isSuperadmin(user) {
  return user?.role === ROLES.SUPERADMIN;
}
